module.exports = __webpack_public_path__ + "img/IMG_2254_L_Foamcore_MockedUp.b0b9ce8b.jpg";